import { useEffect } from "react";
import axios from "axios";
import { message } from "antd";
import moment from "moment";

export default function useStoryDetails({
  storyId, setStoryId, mode, setMode, storyTitle, setStoryTitle, storyDescription, setStoryDescription,
  storyCategory, setStoryCategory, storyCoverImg, setStoryCoverImg, storyDifficulty, setStoryDifficulty,
}) {

  //#region LOAD STORY
  useEffect(() => {
    const loadStory = async () => {
      if (!storyId) return;
      try {
        const res = await axios.get(`/api/stories/${storyId}`);
        const story = res.data;
        console.log("loaded story:", story);
        setStoryTitle(story.title || "");
        setStoryDescription(story.desc || "");
        setStoryCategory(story.cat || "");
        setStoryCoverImg(story.img || "");
        setStoryDifficulty(story.difficulty_level ?? 3);
        setMode("edit");
      } catch (err) {
        console.error("Failed to load story", err);
      }
    };
    loadStory();
  }, [
    storyId, setMode, setStoryTitle, setStoryDescription, setStoryCategory, setStoryCoverImg, setStoryDifficulty
  ]);
  //#endregion

  //#region HELPERS
  const handleTitleChange = (value) => {
    setStoryTitle(value);
  };

  const handleCoverImageChange = (value) => {
    setStoryCoverImg(value);
  };

  const handleStoryCategoryChange = (value) => {
    setStoryCategory(value);
  };

  const handleStoryDifficultyChange = (value) => {
    setStoryDifficulty(value);
  };
  //#endregion

  //#region VALIDATION
  const validateStory = () => {
    if (!storyTitle?.trim()) {
      message.warning("Story title is required.");
      return false;
    }

    if (!storyDescription?.trim()) {
      message.warning("Story description is required.");
      return false;
    }

    return true;
  };
  //#endregion

  //#region SAVE STORY
  const saveStory = async () => {
    try {
      if (!validateStory()) return;
      let responseStoryId = storyId;
      if (mode !== "edit") {
        const res = await axios.post("/api/stories", {
          title: storyTitle,
          desc: storyDescription,
          cat: storyCategory,
          difficulty_level: storyDifficulty,
          img: storyCoverImg || "logo.png",
          date: moment().format("YYYY-MM-DD HH:mm:ss"),
        });
        responseStoryId = res.data;
        setStoryId(responseStoryId);
        setMode("edit");
        message.success("Story created");
      } else {
        await axios.put(`/api/stories/${storyId}`, {
          title: storyTitle,
          desc: storyDescription,
          cat: storyCategory,
          difficulty_level: storyDifficulty,
          img: storyCoverImg || "logo.png",
          date: moment().format("YYYY-MM-DD HH:mm:ss"),
        });
        message.success("Story updated");
      }      
      return responseStoryId;
    } catch (err) {
      console.error(err);
      message.error("Save story failed");
    }
  };
  //#endregion

  return {
    storyTitle, storyDescription, storyCategory, storyCoverImg, storyDifficulty,
    handleTitleChange, handleCoverImageChange, handleStoryCategoryChange, handleStoryDifficultyChange,
    saveStory, validateStory,
  };
}